import React from "react";
import SoarCard from "./SoarCard";
import { getFieldName, getFieldDate } from "../../scripts/helperScripts";

const ClientPayorCard = ({ clientPayor, onEdit }) => {
  return (
    <SoarCard
      cardBodyBg={clientPayor.ccx_expdate ? "bg-warning" : "card-body-safy p-2"}
      title={clientPayor.ccx_name}
      showEdit={onEdit}
      body={
        <>
          <div className="row mx-0">
            <div className="col-4 ps-0">Payor:</div>
            <div className="col pe-0">
              <div className="fw-bold float-end">
                {getFieldName(clientPayor.ccx_payor)}
              </div>
            </div>
          </div>
          <div className="row mx-0">
            <div className="col-4 ps-0">Group Plan:</div>
            <div className="col pe-0">
              <div className="fw-bold float-end">
                {clientPayor.ccx_groupname}
              </div>
            </div>
          </div>
          {clientPayor.ccx_id1 && (
            <div className="row mx-0">
              <div className="col-4 ps-0">ID 1:</div>
              <div className="col pe-0">
                <div className="fw-bold float-end">{clientPayor.ccx_id1}</div>
              </div>
            </div>
          )}
          {clientPayor.ccx_id2 && (
            <div className="row mx-0">
              <div className="col-4 ps-0">ID 2:</div>
              <div className="col pe-0">
                <div className="fw-bold float-end">{clientPayor.ccx_id2}</div>
              </div>
            </div>
          )}
          <div className="row mx-0">
            <div className="col-4 ps-0">Rank:</div>
            <div className="col pe-0">
              <div className="fw-bold float-end">
                {getFieldName(clientPayor.ccx_payorrank)}
              </div>
            </div>
          </div>
          <div className="row mx-0">
            <div className="col-4 ps-0">Effective Date:</div>
            <div className="col pe-0">
              <div className="fw-bold float-end">
                {getFieldDate(clientPayor.ccx_effdate)}
              </div>
            </div>
          </div>
          {clientPayor.ccx_expdate && (
            <div className="row mx-0">
              <div className="col-4 ps-0">Expiration Date:</div>
              <div className="col pe-0">
                <div className="fw-bold float-end">
                  {getFieldDate(clientPayor.ccx_expdate)}
                </div>
              </div>
            </div>
          )}
          {clientPayor.ccx_notes ? (
            <div className="row mx-0">
              <div className="col-4 ps-0">Notes:</div>
              <div className="col pe-0">
                <div
                  className="fw-bold float-end"
                  style={{ wordBreak: "break-word" }}
                >
                  {clientPayor.ccx_notes.length > 200
                    ? `${clientPayor.ccx_notes.slice(0, 198)}...`
                    : clientPayor.ccx_notes}
                </div>
              </div>
            </div>
          ) : null}
        </>
      }
    />
  );
};

export default ClientPayorCard;
